import React, { Component } from "react";
import styled from "styled-components";
import { get } from "lodash";
import numeral from 'numeral';
import moment from 'moment';
import { ModuleEmptyButton, LOAN_STATUSES, LOAN_SENIORITY_TYPES, DEAL_METRICS, ModuleBase, LabelDollarFormatted } from "@loanbossinc/component-library";
import { LoanBodySummary } from "./loanBodySummary";
import LoanHeader from "./loanHeader";
import { Collapse } from "@material-ui/core";

const StyledBody = styled.div`
&& {
    height: 288px;
    width: 648px;
}`;

const bodySummaryMetrics = [
    { label: 'LOAN AMOUNT', field: "details.amount", formatter:(value) => numeral(value).format('$0,0')}
    , { label: 'PREPAYMENT PENALTY', field: "details.prepaymentPenalty", suppField: "details.isLockout", formatter:(value) => numeral(value).format('$0,0'), altFormatter:(value) => "LOCKOUT"}
    , { label: 'ALL-IN RATE', field: "details.allInRateRaw", formatter: (value) => numeral(value).format('0.00%') }
    , { label: 'RATE TYPE', field: "details.rateTypeRef.name", formatter: (value) => value }
    , { label: 'MATURITY', field: "details.maturityDate", formatter: (value) => moment(value).utcOffset(0, true).format('MM/DD/YYYY') }
    , { label: 'SPREAD', field: "details.loanSpreadRaw", formatter: (value) => numeral(value).format('0.00%') }
];

const MAX_LENDERS_TO_SHOW = 3;

export class LoanSummary extends Component {
    state = {
        bodySummaryDealMetric: [],
    }

    componentDidMount() {
        this.findBodySummaryDealMetrics();

      }
    componentDidUpdate(prevProps, prevState) {
        if (this.props !== prevProps) {
            this.findBodySummaryDealMetrics();
        }
    }

    findBodySummaryDealMetrics = () => {
        const { data } = this.props;
        if (!data) return;
        
        const bodySummaryDealMetric = bodySummaryMetrics.reduce((accum, cur) => {
            const value = get(data, cur.field);
            let useAltFormatter = false
            if(cur.suppField)
                useAltFormatter = get(data, cur.suppField);

            const metricValue = useAltFormatter ? cur.altFormatter(value) : cur.formatter(value);
            accum.push(
                {
                    label: cur.label,
                    metricValue
                });
            return accum;
        }, []);

        this.setState({ bodySummaryDealMetric });
    }

    handleHeaderClick = () => {
        const { isSummaryView } = this.state;
        this.setState({ isSummaryView: !isSummaryView });
    }

    renderBodySummary = () => {
        return (
            <StyledBody>
                <LoanBodySummary metrics={this.state.bodySummaryDealMetric} data={this.props.data} />
            </StyledBody>
        )
    }

    renderHeaderAndBody = () => {
        const { data, authentication } = this.props;
        return (
            <ModuleBase elevation={0}>
                <LoanHeader loan={ data } authentication={ authentication } />
                {this.renderBodySummary()}
            </ModuleBase>
        )
    }

    render() {
        return (<>{this.renderHeaderAndBody()}</>)
    }
}
